import { getLocale, intlLocale, type Locale } from './locale';

/**
 * Fechas y números en el idioma activo. Antes cada pantalla escribía 'es-CO' a
 * mano (y el panel de operador no escribía nada, así que salía en el idioma de
 * la máquina). Todo pasa por acá para que cambiar de idioma cambie también el
 * "12 sept 2026" por "Sep 12, 2026".
 *
 * Reciben el locale opcional para que un componente que ya tiene el de
 * `useLocale()` re-renderice al cambiarlo; sin él, leen el del store.
 */
type DateInput = string | number | Date;

function toDate(value: DateInput): Date {
  return value instanceof Date ? value : new Date(value);
}

/** "12 sept 2026" / "Sep 12, 2026". */
export function formatDate(
  value: DateInput,
  options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short', year: 'numeric' },
  locale: Locale = getLocale(),
): string {
  return toDate(value).toLocaleDateString(intlLocale(locale), options);
}

/** Fecha y hora completas. */
export function formatDateTime(
  value: DateInput,
  options?: Intl.DateTimeFormatOptions,
  locale: Locale = getLocale(),
): string {
  return toDate(value).toLocaleString(intlLocale(locale), options);
}

/** Sólo la hora. */
export function formatTime(
  value: DateInput,
  options: Intl.DateTimeFormatOptions = { hour: 'numeric', minute: '2-digit' },
  locale: Locale = getLocale(),
): string {
  return toDate(value).toLocaleTimeString(intlLocale(locale), options);
}

/** "12.345" / "12,345". */
export function formatNumber(
  value: number,
  options?: Intl.NumberFormatOptions,
  locale: Locale = getLocale(),
): string {
  return value.toLocaleString(intlLocale(locale), options);
}
